module.exports = __webpack_public_path__ + "static/media/html.8cf356af.png";